import React, { useState, useEffect, useCallback } from 'react';
import {
  Form,
  Space,
  Input,
  Button,
  Table,
  Modal,
  Row,
  Col,
  DatePicker,
  InputNumber,
  Select,
  message,
} from 'antd-v5';
import { PlusOutlined } from '@ant-design/icons';
import moment from 'moment';

import { getBusinessStallList } from '../../../../../state/request/serve';
import { layout, tailLayout } from '../../../../add-services/enum';

import './index.less';
import { useSelector } from 'react-redux';
import {
  getStallEmploys,
  getStallBusinessSignProductList,
  addStallBusinessSignProduct,
} from '../../../../../state/request/stall';
import dayjs from 'dayjs';

const Serve = (props) => {
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const { stallDetails } =
    useSelector((state) => {
      return {
        stallDetails: state?.stall?.stallDetails || {},
      };
    }) ?? {};
  const { name, adminUid, personName, personPhone } = stallDetails;
  const [list, setList] = useState([]);
  const [employList, setEmployList] = useState([]);
  const [open, setOpen] = useState(false);
  const [businessSignProductList, setBusinessSignProductList] = useState([]);
  const { stallId } = props;

  const getData = useCallback(
    async (query = {}) => {
      const { code, data = [] } = await getBusinessStallList({ stallId, ...query });
      if (code === 200) {
        setList(data);
      }
    },
    [stallId],
  );

  useEffect(() => {
    getData();
  }, [getData]);

  useEffect(() => {
    if (!open) {
      form2.resetFields();
    }
  }, [open]);

  useEffect(() => {
    if (open && employList.length === 0) {
      getStallEmployList();
    }
  }, [open, employList]);

  useEffect(() => {
    if (open && businessSignProductList.length === 0) {
      getBusinessSignProductList();
    }
  }, [open, businessSignProductList]);

  const getStallEmployList = async () => {
    const res = await getStallEmploys(stallId, {});
    const { data } = res;
    setEmployList(data || []);
  };

  const getBusinessSignProductList = async () => {
    const res = await getStallBusinessSignProductList(stallId, {});
    setBusinessSignProductList(res || []);
  };

  const onFinish = (values) => {
    getData(values);
  };

  const submitValues = async (values) => {
    const { stallName, personId, phone, productId, paymentAmount, payTime } = values;
    const res = await addStallBusinessSignProduct({
      stallId,
      productId,
      personId,
      paymentAmount,
      payTime: dayjs(payTime).valueOf(),
    });
    if (res.code === 200) {
      message.success('新增成功');
      setOpen(false);
      getData();
    }
  };

  const ExtraContent = () => {
    return (
      <Form {...layout} form={form} layout='inline' onFinish={onFinish} className='header'>
        <Space wrap>
          <Form.Item name='businessName'>
            <Input placeholder='请输入功能名称查询' style={{ width: 240 }} />
          </Form.Item>
          <Form.Item {...tailLayout}>
            <Button type='primary' htmlType='submit'>
              查询
            </Button>
          </Form.Item>
        </Space>
        <Button
          style={{ position: 'absolute', right: 16 }}
          type='primary'
          icon={<PlusOutlined />}
          onClick={() => setOpen(true)}
        >
          新增
        </Button>
      </Form>
    );
  };

  const columns = [
    {
      title: '增值服务名称',
      dataIndex: 'name',
    },
    {
      title: '剩余数量',
      dataIndex: 'balance',
      render: (t) => t || '--',
    },
    {
      title: '到期时间',
      dataIndex: 'expireTime',
      render: (t) => (t ? moment(t).format('YYYY-MM-DD HH:mm:ss') : '--'),
    },
    {
      title: '剩余有效期',
      dataIndex: 'duration',
      render: (t) => (t ? `${t}天` : '--'),
    },
    {
      title: '是否过期',
      dataIndex: 'expireFlag',
      render: (flag) => (flag ? '是' : '否'),
    },
  ];

  return (
    <div className='serve'>
      <ExtraContent />
      <Table dataSource={list} columns={columns} pagination={false} scroll={{ x: 'max-content' }} />
      <Modal
        title='新增增值服务'
        open={open}
        onOk={() => {
          form2.validateFields().then((values) => {
            submitValues(values);
          });
        }}
        onCancel={() => {
          setOpen(false);
        }}
        width={600}
      >
        <Form
          labelCol={{ flex: '105px' }}
          labelAlign='left'
          form={form2}
          initialValues={{ stallName: name, personId: adminUid, phone: personPhone }}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label='付款时间'
                name='payTime'
                rules={[{ required: true, message: '请选择付款时间' }]}
              >
                <DatePicker style={{ width: '100%' }} placeholder='请选择付款时间' />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label='商行名称' name='stallName'>
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label='付款人'
                name='personId'
                rules={[{ required: true, message: '请选择付款人' }]}
              >
                <Select
                  placeholder='请选择付款人'
                  options={employList
                    .filter((item) => item.enable)
                    .map((item) => ({
                      label: item.name,
                      value: item.personId,
                    }))}
                  onChange={(value) => {
                    const employee = employList.find((item) => item.personId === value);
                    form2.setFieldsValue({
                      phone: employee.phone,
                    });
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label='付款人手机号' name='phone'>
                <Input disabled placeholder='请输入付款人手机号' />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label='服务'
                name='productId'
                rules={[{ required: true, message: '请选择服务' }]}
              >
                <Select
                  style={{ width: '100%' }}
                  placeholder='请选择服务'
                  options={businessSignProductList.map((item) => ({
                    label: item.productDesc,
                    value: item.id,
                  }))}
                  onChange={(value) => {
                    const product = businessSignProductList.find((item) => item.id === value);
                    form2.setFieldsValue({
                      paymentAmount: product.discountAmount,
                    });
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label='付款金额'
                name='paymentAmount'
                rules={[{ required: true, message: '请输入付款金额' }]}
              >
                <InputNumber style={{ width: '100%' }} min={0} placeholder='请输入付款金额' />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default Serve;
